"use client";

import { useEffect, useState } from "react";

import { useBookingDrawer } from "@/lib/booking-context";
import { offersFreeConsultation } from "@/lib/consultation";
import { usePublicPathname } from "@/lib/public-pathname";
import { regionFromPathname, regionPath } from "@/lib/region";

export default function LpDock() {
  const pathname = usePublicPathname();
  const region = regionFromPathname(pathname);
  const { setOpen: setBookingOpen } = useBookingDrawer();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY <= 40) {
        setShown(false);
        return;
      }
      const legal = document.querySelector("[data-footer-legal]");
      if (legal) {
        const r = legal.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > window.innerHeight - 100) {
          setShown(false);
          return;
        }
      }
      setShown(true);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      data-floating-dock
      className="pointer-events-none fixed inset-x-4 bottom-[max(1rem,env(safe-area-inset-bottom))] z-40 flex justify-center md:inset-x-auto md:right-8 md:bottom-8"
      aria-hidden={!shown}
      inert={!shown}
    >
      <nav
        aria-label="Shortcuts"
        className={`bg-navy-03/75 pointer-events-auto flex items-center rounded-full px-3 py-2.5 shadow-[0_20px_48px_-12px_rgba(0,0,0,0.45)] ring-1 ring-white/15 backdrop-blur-2xl backdrop-saturate-150 transition-all duration-300 ${
          shown ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        <a
          href={regionPath("/", region)}
          aria-label="Home"
          className="mr-2.5 flex size-10 shrink-0 items-center justify-center rounded-full bg-white transition-opacity hover:opacity-90"
        >
          <span
            aria-hidden
            className="bg-teal-07 h-4 w-6 translate-x-[4.9%] translate-y-[14.8%]"
            style={{
              maskImage: "url(/assets/logo/optilase/mark-op.svg)",
              WebkitMaskImage: "url(/assets/logo/optilase/mark-op.svg)",
              maskSize: "contain",
              WebkitMaskSize: "contain",
              maskRepeat: "no-repeat",
              WebkitMaskRepeat: "no-repeat",
              maskPosition: "center",
              WebkitMaskPosition: "center",
            }}
          />
          <span className="sr-only">Home</span>
        </a>

        <button
          type="button"
          onClick={() => setBookingOpen(true, "lp-dock")}
          className="bg-teal-07 flex items-center gap-1.5 rounded-full px-5 py-2.5 text-sm font-bold text-white shadow-[0_4px_16px_-4px_rgba(0,133,124,0.5)] transition-transform hover:scale-105 active:scale-95"
        >
          {offersFreeConsultation(pathname) ? "Book a free consultation" : "Book consultation"}
        </button>
      </nav>
    </div>
  );
}
